export default __webpack_public_path__ + "static/B0221-15af05d4f0f085ec2fef7422747d7141.png";